import {
  handleWithErrorMessage,
  handleWithGlobalMessage
} from "@/services/utils";
import api from "@/services/modules/organisations/organisation-interview-format-templates";
import {
  SET_IS_FETCHING_ORGANISATION_INTERVIEW_FORMAT_TEMPLATES,
  SET_ORGANISATION_INTERVIEW_FORMAT_TEMPLATES
} from "@/store/modules/organisations/organisation-interview-format-templates/mutations";
import { BASE_PAGINATION_REQUEST_PARAMS } from "@/constants/pagination";

export const FETCH_ORGANISATION_INTERVIEW_FORMAT_TEMPLATES =
  "FETCH_ORGANISATION_INTERVIEW_FORMAT_TEMPLATES";
export const CREATE_INTERVIEW_FORMAT_TEMPLATE =
  "CREATE_INTERVIEW_FORMAT_TEMPLATE";
export const EDIT_INTERVIEW_FORMAT_TEMPLATE = "EDIT_INTERVIEW_FORMAT_TEMPLATE";

const actions = {
  async [FETCH_ORGANISATION_INTERVIEW_FORMAT_TEMPLATES](
    { commit, dispatch },
    params
  ) {
    return handleWithErrorMessage({
      dispatch,
      request: () => api(commit).getAll(params),
      setLoadingFunction: isLoading =>
        commit(
          SET_IS_FETCHING_ORGANISATION_INTERVIEW_FORMAT_TEMPLATES,
          isLoading
        ),
      setDataFunction: ({ data }) =>
        commit(SET_ORGANISATION_INTERVIEW_FORMAT_TEMPLATES, data)
    });
  },
  async [CREATE_INTERVIEW_FORMAT_TEMPLATE]({ commit, dispatch }, data) {
    await handleWithGlobalMessage(() => api(commit).add(data), dispatch);
    dispatch(
      FETCH_ORGANISATION_INTERVIEW_FORMAT_TEMPLATES,
      BASE_PAGINATION_REQUEST_PARAMS
    );
  },
  async [EDIT_INTERVIEW_FORMAT_TEMPLATE]({ commit, dispatch }, data) {
    await handleWithGlobalMessage(() => api(commit).edit(data), dispatch);
    dispatch(FETCH_ORGANISATION_INTERVIEW_FORMAT_TEMPLATES);
  }
};

export default actions;
